var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.53033 2.46967C9.82322 2.76256 9.82322 3.23744 9.53033 3.53033L7.0605 6L9.53033 8.46967C9.80492 8.74426 9.82208 9.17879 9.58181 9.47337L9.53033 9.53033C9.23744 9.82322 8.76256 9.82322 8.46967 9.53033L6 7.0605L3.53033 9.53033C3.23744 9.82322 2.76256 9.82322 2.46967 9.53033C2.17678 9.23744 2.17678 8.76256 2.46967 8.46967L4.9395 6L2.46967 3.53033C2.19508 3.25574 2.17792 2.82121 2.41818 2.52663L2.46967 2.46967C2.76256 2.17678 3.23744 2.17678 3.53033 2.46967L6 4.9395L8.46967 2.46967C8.76256 2.17678 9.23744 2.17678 9.53033 2.46967Z",
    fill: "#2563EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.f8aed0697a6e4a5dcf0f6a27412ce7df.svg";
export { ForwardRef as ReactComponent };